var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m675 75v150h-562.5c-27.898 0-57.977 11.102-79.727 32.852s-32.852 51.75-32.852 79.727v525c0 27.898 11.102 57.977 32.852 79.727s51.75 32.852 79.727 32.852h112.5v-150h-75v-450h525v150l225-225-225-225zm300 150v150h75v450h-525v-150l-225 225 225 225v-150h562.5c27.898 0 57.977-11.102 79.727-32.852s32.852-51.75 32.852-79.727v-525c0-27.898-11.102-57.977-32.852-79.727s-51.75-32.852-79.727-32.852h-112.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.387aeb68561c0382c64f4bbefb7c3302.svg";
export { ForwardRef as ReactComponent };